<template>
  <div id="app">
    <section class="content">
      <div class="child-name">
        <div class="letters">
          <img src="./assets/name.png">
          <!--<img src="./assets/I.png">-->
        </div>
        <!--<div class="letters">
          <img src="./assets/S.png">
          <img src="./assets/E.png">
        </div>-->
      </div>
      <div class="birthdate">
        <span>{{ date.getDate() }}<sup>er</sup> {{ monthNames[date.getMonth()] }} {{ date.getFullYear() }}</span>
      </div>
      <div class="countdown">
        <span>Ça fait {{ count.days }} jours, {{ count.hours }} heures,</span>
        <span>{{ count.minutes }} minutes et {{ count.seconds }} secondes !</span>
      </div>
      <div class="glide">
        <vue-picture-swipe @hook:mounted="picturesMounted" ref="pictures" :items="items"></vue-picture-swipe>
      </div>
      <!--<div class="glide">
        <div class="glide__track" data-glide-el="track">
          <ul class="glide__slides">
            <li class="glide__slide"><img src="https://farm1.staticflickr.com/587/31772469552_35baa634e7_m.jpg"/></li>
            <li class="glide__slide"><img src="https://farm1.staticflickr.com/382/31079902314_75f3eb466f_m.jpg"/></li>
            <li class="glide__slide"><img src="https://farm6.staticflickr.com/5601/15039453214_8724d9f35b_m.jpg"/></li>
            <li class="glide__slide"><img src="https://farm1.staticflickr.com/382/31079902314_75f3eb466f_m.jpg"/></li>
            <li class="glide__slide"><img src="https://farm6.staticflickr.com/5601/15039453214_8724d9f35b_m.jpg"/></li>
          </ul>
          <div class="glide__arrows" data-glide-el="controls">
            <button class="glide__arrow glide__arrow--left" data-glide-dir="<">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                <path d="M0 12l10.975 11 2.848-2.828-6.176-6.176H24v-3.992H7.646l6.176-6.176L10.975 1 0 12z"></path>
              </svg>
            </button>
            <button class="glide__arrow glide__arrow--right" data-glide-dir=">">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                <path d="M13.025 1l-2.847 2.828 6.176 6.176h-16.354v3.992h16.354l-6.176 6.176 2.847 2.828 10.975-11z"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>-->
      <ul class="links">
        <li><a :href="links.list" target="_blank">Liste de naissance</a></li>
        <!--<li><a href="#" @click="setMessageMode($event, true)">Écrivez-moi&nbsp;!</a></li>-->
      </ul>
    </section>
    <footer>
      <ul>
        <li>Noémi et Hubert LOBIT-TILMANNE</li>
        <li>Vieux chemin de Nivelles 74</li>
        <li>1440 Braine-le-Château Belgique</li>
      </ul>
      <ul>
        <li>Noémi&nbsp;: +32 498 40 64 32</li>
        <li>Hubert&nbsp;: +32 489 98 88 59</li>
      </ul>
    </footer>
    <div class="modal" v-bind:class="{ visible: messageMode }">
      <div class="modal-header">
        <div class="space"></div>
        <div class="close-button">
          <span class="close" @click="setMessageMode($event, false)">&times;</span>
        </div>
      </div>
      <div class="modal-content">
        <form name="message-data" autocomplete="off" v-on:submit.prevent="onSubmit">
          <input type="text" name="senderName" id="senderName" placeholder="Votre nom">
          <input type="email" name="senderAddress" id="senderAddress" placeholder="Votre email">
          <textarea name="message" id="message" placeholder="Et le petit message pour Julie…" rows="8"></textarea>
          <ul class="actions">
            <li>
              <input name="submit" type="submit" value="C'est parti !" class="special">
            </li>
          </ul>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Glide from '@glidejs/glide'

const birthdate = new Date(2021, 1, 1, 4, 26, 0, 0)

export default {
  name: 'app',
  data () {
    return {
      monthNames: [
        'JAN', 'FÉVRIER', 'MAR', 'AVR', 'MAI', 'JUIN',
        'JUILLET', 'AOÛT', 'SEPTEMBRE', 'OCT', 'NOV', 'DEC'
      ],
      date: birthdate,
      count: {},
      interval: null,
      messageMode: false,
      links: {
        list: 'https://www.kadolog.com/fr/list/bienvenue-julie'
      },
      items: []
    }
  },
  methods: {
    getCount () {
      var targetDate = this.date.getTime()

      // Get todays date and time
      var now = new Date().getTime()

      // Find the distance between now and the count down date
      var distance = now - targetDate

      // Time calculations for days, hours, minutes and seconds
      return {
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((distance % (1000 * 60)) / 1000)
      }
    },
    startCount () {
      this.interval = setInterval(() => {
        this.count = this.getCount()
      }, 1000)
    },
    stopCount () {
      if (this.interval) {
        clearInterval(this.interval)
      }
    },
    setMessageMode ($event, value) {
      this.messageMode = value
    },
    onSubmit ($event) {
      this.sending = true
      var form = $event.target
      var request = new XMLHttpRequest()

      var submitButton = form.elements.namedItem('submit')
      submitButton.disabled = true

      request.onreadystatechange = function (response) {
        if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
          this.sending = false
          submitButton.value = 'Message envoyé !'
          form.reset()
        }
      }

      request.open('POST', '/api/message')
      request.setRequestHeader('Content-Type', 'application/json')
      request.send(JSON.stringify({
        senderName: form.elements['senderName'].value,
        senderAddress: form.elements['senderAddress'].value,
        text: form.elements['message'].value
      }))
    },
    picturesMounted () {
      axios.get('/api/photos')
        .then(response => {
          this.items = response.data.map(e => ({
            src: e['url'],
            thumbnail: e['thumbnail'],
            w: e['width'],
            h: e['height']
          }))
          this.items.pop()
          setTimeout(() => {
            const swipe = this.$refs['pictures'].$el
            swipe.classList.add('glide__track')
            swipe.dataset.glideEl = 'track'
            swipe.firstChild.classList.add('glide__slides')
            for (let i = 0; i < swipe.firstChild.children.length; i++) {
              swipe.firstChild.children[i].classList.add('glide__slide')
            }
            new Glide('.glide', {
              autoplay: 4000,
              type: 'carousel',
              perView: 4,
              focusAt: 'center',
              breakpoints: {
                800: {
                  focusAt: 'center',
                  perView: 2
                },
                480: {
                  focusAt: 'center',
                  perView: 1
                }
              }
            }).mount()
          }, 0)
        })
    }
  },
  created () {
    this.count = this.getCount()
    this.startCount()
  },
  destroyed () {
    this.stopCount()
  }
}
</script>

<style lang="scss">
$color: rgb(166, 83, 80);

// Required Core Stylesheet
@import "~@glidejs/glide/src/assets/sass/glide.core";

// Optional Theme Stylesheet
@import "~@glidejs/glide/src/assets/sass/glide.theme";

@font-face {
  font-family: 'TempusSansITC';
  src: url('./fonts/TempusSansITC.eot?#iefix') format('embedded-opentype'),
       url('./fonts/TempusSansITC.woff') format('woff'),
       url('./fonts/TempusSansITC.ttf')  format('truetype'),
       url('./fonts/TempusSansITC.svg#TempusSansITC') format('svg');
  font-weight: normal;
  font-style: normal;
}

html {
  background: url('./assets/cute-rabbit-easter-eggs-seamless-pattern_28892-753_.jpg');
}

body {
  margin: 0;
}

#app {
  font-family: 'TempusSansITC' !important;
  // font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  // margin-top: 60px;

  display: flex;
  flex-direction: column;
  min-height: 100vh;
  align-items: center;
  justify-content: center;
}

.content {
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.child-name {
  margin: 1.5em 0 1.5em 0;
  padding: 0 16px;

  .letters {
    display: inline-block;
    height: 6em;
  }

  img {
    max-width: 100%;
    max-height: 100%;
    margin: 0 5px 0 5px;
    opacity: 0.8;
    transition: opacity 1s;

    &:hover {
      opacity: 1;
    }
  }
}

.birthdate {
  margin: 0 0 0.4em 0;
  padding: 0 16px;
  font-weight: 400;
  font-size: 3em;
  opacity: 1;
  color: $color;
  line-height: 1.5em;

  span {
    border-bottom: 1px solid;
    border-top: 1px solid;
  }
}

.countdown {
  padding: 0 16px;
  span {
    white-space: pre;
  }
}

.links {
  a {
    color: #3f49b9;
    font-weight: 600;
    opacity: 0.6;
    transition: opacity 0.7s;

    &:hover {
      opacity: 1;
    }
  }
}

/* The Modal (background) */
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 10; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.8); /* Black w/ opacity */

  &.visible {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}

/* Modal Content/Box */
.modal-header {
  width: 100%;
  display: flex;
  .space {
    flex: 1;
  }
  .close-button {
    padding: 20px;
  }
}

.modal-content {
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* The Close Button */
.close {
  color: #eee;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

footer {
  font-size: 0.8em;
  margin-bottom: 1em;
  opacity: 0.6;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0 16px;
}

li {
  display: inline-block;
  margin: 0 10px;
}

::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #aaa;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: #aaa;
}

::-ms-input-placeholder { /* Microsoft Edge */
  color: #aaa;
}

input, textarea {
  box-sizing: border-box;
  appearance: none;
  background: rgba(157, 157, 157, 0.6);
  border-radius: 0;
  border: none;
  color: #fff;
  display: block;
  outline: 0;
  padding: 0 1em;
  text-decoration: none;
  width: 100%;
  font-size: 1em;
  margin: 0.5em 0;
}

form {
  width: 640px;
  max-width: 90%;
  padding: 20px;
}

input {
  height: 2em;
}

textarea {
  padding-top: 0.5em;
  padding-bottom: 0.5em;
}

input[type="submit"] {
  background-color: #d16d53;
  border: 0;
  box-shadow: none;
  color: #ffffff !important;
  cursor:pointer;

  &:hover {
    background-color: #d16d89;
  }
}

.glide {
  z-index: 2;
  margin: 30px 0;
  background-color: rgba(0, 70, 92, 0.16);

  .glide__arrow {
    background-color: rgba(156, 59, 59, 0.6);
  }
  .glide__slides {
    max-height: 150px;
  }
  .glide__slide {
    filter: drop-shadow(12px 12px 25px rgba(0, 0, 0, 0.5));
    margin-left: 0;
    margin-right: 10px;
    img {
      max-height: 140px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue